export default {
  contact: {
    hero: {
      eyebrow: 'Contact',
      title: 'Écrivez-nous',
      lead: "Qu'il s'agisse d'informations, de planification concrète ou d'une visite sur place : nous attendons votre message.",
    },
    info: {
      partner: 'Votre partenaire en technologie de sécurité',
      owner: 'Dirigeant',
      address: 'Adresse',
      phone: 'Téléphone',
      email: 'Email',
      hours: 'Horaires',
      area: "Zone d'intervention",
      viewAreas: "Voir toutes les zones d'intervention",
    },
    form: {
      title: 'Demande de projet',
      lead: 'Remplissez le formulaire. Nous vous répondrons rapidement.',
      customerType: 'Particulier ou professionnel *',
      select: 'Veuillez choisir',
      privat: 'Particulier',
      gewerbe: 'Professionnel',
      name: 'Nom *',
      company: 'Entreprise',
      phone: 'Téléphone',
      email: 'Email *',
      projectLocation: 'Lieu du projet',
      objectType: 'Type de bien',
      objEfh: 'Maison individuelle',
      objMfh: 'Immeuble',
      objLaden: 'Commerce / boutique',
      objBuero: 'Bureau / cabinet',
      objGastronomie: 'Restauration',
      objLager: 'Entrepôt / logistique',
      objWerkstatt: 'Atelier / artisanat',
      objSonstige: 'Autre',
      service: 'Service souhaité',
      svcBeratung: 'Premier conseil',
      svcPlanung: 'Planification et devis',
      svcInstallation: 'Installation et configuration',
      svcErweiterung: "Extension d'un système existant",
      svcWartung: 'Maintenance / suivi',
      svcCare: 'Demande SSG Care',
      systemStatus: 'État du système',
      stNeu: 'Nouveau système',
      stBestehend: 'Étendre le système existant',
      stAustausch: 'Remplacement complet',
      stUnsicher: 'Pas encore sûr',
      message: 'Message',
      messagePlaceholder: 'Décrivez brièvement votre projet ou vos questions...',
      maxChars: 'Maximum 500 caractères',
      fileUpload: 'Téléversement de fichier',
      fileHint: 'Photos, plans ou autres documents (optionnel)',
      fileNote: 'Remarque : les téléversements sont traités comme « Uncollectable ».',
      callback: 'Créneau de rappel préféré',
      callbackNone: 'Pas de rappel souhaité',
      vormittag: 'Matin',
      nachmittag: 'Après-midi',
      abend: 'Soir',
      consent: "J'ai lu la politique de confidentialité et j'accepte le traitement de mes données pour cette demande. *",
      success: 'Merci pour votre demande. Nous vous répondrons rapidement.',
      submit: 'Envoyer la demande',
      submitting: 'Envoi...',
    },
  },
};